import React from "react";
import {Button as MuiButton, useTheme} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Reusable outlined button
 * - Acts as a React Router link when `to` is provided
 * - Acts as a normal button otherwise
 * - White border & text
 * - Hover fills with theme.palette.primary.default
 */
const SMButtonBrown = ({
                           to,
                           children,
                           onClick,
                           disabled = false,
                           fullWidth = false,
                           sx,
                           ...props
                       }) => {
    const theme = useTheme();
    const isLink = Boolean(to);

    return (
        <MuiButton
            variant="outlined"
            size="large"
            fullWidth={fullWidth}
            disabled={disabled}
            onClick={onClick}
            component={isLink ? RouterLink : "button"}
            to={isLink ? to : undefined}
            sx={{
                minWidth: 180,
                borderRadius: 20,
                color: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                fontFamily: theme.typography.fontFamily,
                fontWeight: 900,
                fontSize: {
                    xs: "1.5rem",
                    sm: "2rem",
                    md: "2rem",
                    lg: "2rem",
                    xl: "2rem",
                },
                textTransform: "none",
                textAlign: "center",

                "&:hover": {
                    backgroundColor: theme.palette.primary.main,
                    backdropFilter: "blur(6px)",
                    WebkitBackdropFilter: "blur(6px)",
                    borderColor: theme.palette.primary.main,
                    color: "#ffffff",
                },

                "&.Mui-disabled": {
                    color: "rgba(255,255,255,0.5)",
                    borderColor: "rgba(255,255,255,0.5)",
                },

                ...sx,
            }}
            {...props}
        >
            {children}
        </MuiButton>
    );
};

export default SMButtonBrown;
